import React, { Fragment, useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../toast/SetToast";
import Toast from "../../toast/SetToast";
import { useFirestore } from "../../../../hook/useFirestore";
import { DoctorForm } from "./DoctorForm";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../../firebase";

const DoctorRegister = (props) => {
  const { addDocument } = useFirestore("doctors");
  const [nodeOptions, setNodeOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const inputRef = useRef({
    doctorId: "",
    name: "",
    fullnameEn: "",
    fullnameTh: "",
    node: [],
    accessToken: "",
    email: "",
    status: "",
    note: "",
    designation: "",
    licenseId: "",
    doctorType: "",
    // ⬇ add rate fields so admins can type them
    diagnosisCashRate: "",
    diagnosisSocialSecurityRate: "",
    postConsultCashRate: "",
    postConsultSocialSecurityRate: "",
    cpapFollowupCashRate: "",
    cpapFollowupSocialSecurityRate: "",
  });

  // pass currentUser in via props.currentUser (or however you store it)
  const currentUser = props.currentUser;
  const hasPaymentAccess = props.paymentAccess;

  const handleChange = (name) => (e) => {
    inputRef.current[name] = e.target.value;
  };

  const handleSelected = (selectedOption) => {
    setSelectedOptions(selectedOption);
  };

  const handleOnHideModal = () => {
    props.hide();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedNode = selectedOptions.map(function (item) {
      return item.value;
    });

    // base form data (for everyone)
    var formData = {
      doctorId: inputRef.current.doctorId,
      name: inputRef.current.name,
      fullnameEn: inputRef.current.fullnameEn,
      fullnameTh: inputRef.current.fullnameTh,
      node: selectedNode,
      accessToken: inputRef.current.accessToken,
      email: inputRef.current.email,
      status: inputRef.current.status,
      note:
        inputRef.current.note !== undefined && inputRef.current.note !== null
          ? inputRef.current.note
          : "",
      designation:
        inputRef.current.designation !== undefined &&
        inputRef.current.designation !== null
          ? inputRef.current.designation
          : "",
      licenseId:
        inputRef.current.licenseId !== undefined &&
        inputRef.current.licenseId !== null
          ? inputRef.current.licenseId
          : "",
      doctorType:
        inputRef.current.doctorType !== undefined &&
        inputRef.current.doctorType !== null
          ? inputRef.current.doctorType
          : "",
    };

    // only admins can set payment rates on create
    if (hasPaymentAccess) {
      formData.diagnosisCashRate =
        inputRef.current.diagnosisCashRate !== undefined
          ? inputRef.current.diagnosisCashRate
          : "";
      formData.diagnosisSocialSecurityRate =
        inputRef.current.diagnosisSocialSecurityRate !== undefined
          ? inputRef.current.diagnosisSocialSecurityRate
          : "";
      formData.postConsultCashRate =
        inputRef.current.postConsultCashRate !== undefined
          ? inputRef.current.postConsultCashRate
          : "";
      formData.postConsultSocialSecurityRate =
        inputRef.current.postConsultSocialSecurityRate !== undefined
          ? inputRef.current.postConsultSocialSecurityRate
          : "";
      formData.cpapFollowupCashRate =
        inputRef.current.cpapFollowupCashRate !== undefined
          ? inputRef.current.cpapFollowupCashRate
          : "";
      formData.cpapFollowupSocialSecurityRate =
        inputRef.current.cpapFollowupSocialSecurityRate !== undefined
          ? inputRef.current.cpapFollowupSocialSecurityRate
          : "";
    }
    try {
      await addDocument(formData);
      notifyTopRight("บันทึกข้อมูลสำเร็จ");
      props.hide();
    } catch (err) {
      notifyError("บันทึกข้อมูลผิดพลาด ", err);
    }
  };

  const getNodeName = async () => {
    const ref = collection(db, "nodes");
    const docSnap = await getDocs(ref);
    const temp = [];
    docSnap.forEach(function (item) {
      const data = item.data();
      temp.push({ value: data.nodename, label: data.nodename });
    });
    setNodeOptions(temp);
  };

  useEffect(function () {
    getNodeName();
  }, []);

  return (
    <Fragment>
      <Toast />
      <Modal
        className="fade bd-example-modal-lg"
        show={props.show}
        onHide={handleOnHideModal}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Register Doctor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DoctorForm
            onChange={handleChange}
            node={nodeOptions}
            onSelect={handleSelected}
            // ⬇ pass current user so the form can hide rate fields
            currentUser={props.currentUser}
            paymentAccess={props.paymentAccess}
            inputRef={inputRef} // if your DoctorForm needs direct ref access
          />
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
        <div className="d-flex justify-content-center mb-3">
          <Button className="sm" onClick={handleSubmit}>
            Save
          </Button>
          <Button
            className="sm ml-2"
            variant="light"
            onClick={handleOnHideModal}
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
};

export default DoctorRegister;
